/**
 * Feature flag constants for LaunchDarkly
 * Shared between server and frontend
 * Define which flags are available and which ones to expose to frontend
 */

const FEATURE_FLAG_KEYS = {
  NEW_PLG_EXPERIENCE: 'earth-portal-new-plg-experience',
  DISABLE_BILLING_VIEW: 'home-disable-billing-views', // using home's flag to make coordination easier

  // Add more flags here as needed
};

// Only flags listed here will be sent to the browser
// This is a whitelist - not all flags should be exposed to frontend
const FRONTEND_FEATURE_FLAGS = [
  FEATURE_FLAG_KEYS.NEW_PLG_EXPERIENCE,
  FEATURE_FLAG_KEYS.DISABLE_BILLING_VIEW,
];

module.exports = {
  FEATURE_FLAG_KEYS,
  FRONTEND_FEATURE_FLAGS,
};
